theme.initSlideShowHome  =  function(){
    var swiper = new Swiper('.lightSlider-shop', {
        loop: true,
         autoplay: {
          delay: 2000,
         },
        navigation: {
          nextEl: '.chevron-right',
          prevEl: '.chevron-left',
        },
a11y: {
            containerMessage: 'This is a liting section', 
  slideLabelMessage: 'product name',
},
        breakpoints: {
    1200: {
      slidesPerView: 6.5,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 4.5,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 3.5,
      spaceBetween: 20
    },
    320: {
      slidesPerView: 2.5,
      spaceBetween: 20
    }
  }
      });
  
 var swiper = new Swiper(".postalSwiper", {
    slidesPerView: 5,
    spaceBetween: 5,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
       breakpoints: {
           1440: {
        slidesPerView: 5,
        spaceBetween: 5,
      },
      1200: {
        slidesPerView: "auto",
         loop: true,
        slidesPerView: 4.5,
        spaceBetween: 5,
      },
        768: {
         loop: true,
        slidesPerView: 3.5,
        spaceBetween: 5,
      },
        580: {
         loop: true,
        slidesPerView: 2.5,
        spaceBetween: 5,
      },
          300: {
         loop: true,
        slidesPerView: 1.5,
        spaceBetween: 5,
      },

       },
  });

     $('.proudly_certified_logo').slick({
      dots: false,
      arrows:false,
      autoplay: true,
      infinite: true,
      speed: 200,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });

   var swiper = new Swiper('.HomeImageSlider', {
    slidesPerView: 5,          // Number of slides per view on desktop
    spaceBetween: 30,          // Space between slides
    loop: true,                // Enable looping
    autoplay: {
      delay: 2000,             // Autoplay speed (2 seconds)
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
       280: {
        slidesPerView: 2,      // Number of slides per view on mobile
        spaceBetween: 20,
      },
      // When the viewport width is <= 768px (mobile view)
      768: {
        slidesPerView: 2,      // Number of slides per view on mobile
        spaceBetween: 20,
      },
      // When the viewport width is > 768px (desktop view)
      1024: {
        slidesPerView: 3,      // Number of slides per view on desktop
        spaceBetween: 30,
      },
       1200: {
        slidesPerView: 5,      // Number of slides per view on desktop
        spaceBetween: 30,
      }
    }
  });

}
theme.collectiontabs =  function(){
 $('.tabs-main').each(function(){
    $(this).find(".tab_content").hide();
    $(this).find(".tab_content:first").show();
    if($(this).hasClass('tabs-left')){
      // Tab Left
      var tabHeight;
      tabHeight = $(this).find(' ul.tabs').height();
      $(this).find('.tab_container').css('min-height', tabHeight + 10 );
    }
  });
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var $parent = $(this).parents('.tabs-main');
    $parent.find(".tab_content").hide();
    var activeTab = $(this).attr("rel"); 
    $parent.find('.tab_container').find("#"+activeTab).fadeIn();		
    $(this).parent().find("li").removeClass("active");
    $(this).addClass("active");
    $parent.find(".tab_drawer_heading").removeClass("d_active");
    $parent.find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var $parent = $(this).parents('.tabs-main');
    $parent.find(".tab_content").slideUp();
    var d_activeTab = $(this).attr("rel"); 
    $parent.find("#"+d_activeTab).slideDown();
    $parent.find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
    $parent.find("ul.tabs li").removeClass("active");
    $parent.find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    $('html, body').animate({ scrollTop: $parent.find('.tab_container').position().top -100},500);
  });
}
$(function(){
  theme.collectiontabs();
 theme.initSlideShowHome();
});